import React from "react";
import { Box, Chip, LinearProgress } from "@mui/material";

export default function VariantSelectionStatusBar(props) {
  const { options, variant } = props;

  const getFilterChip = (key, displayValue, onDelete) => {
    return (
      <Chip
        label={
          <Box>
            {key.toUpperCase()} <span style={{ color: "#999" }}>|</span>{" "}
            <span style={{ color: "#78374a", textTransform: "capitalize" }}>{displayValue}</span>
          </Box>
        }
        onDelete={onDelete}
      ></Chip>
    );
  };

  let selections = [];
  const map = Object.fromEntries(options);
  for (const [key, value] of Object.entries(variant)) {
    if (value && map[key]) {
      selections.push(getFilterChip(key, value.name, () => props.onDelete(key)));
    }
  }

  let selectionsRequired = options.length;
  const requirementsMet = selections.length >= selectionsRequired;

  return (
    <Box>
      {selections.length > 0 && (
        <Box sx={{ backgroundColor: requirementsMet ? "#ecf7f5" : "#e5f6fd" }}>
          <Box px={2} pt={1.5} pb={1}>
            {selections}
          </Box>
          <LinearProgress
            variant="determinate"
            color={requirementsMet ? "success" : "info"}
            value={requirementsMet ? 100 : (selections.length / selectionsRequired) * 100}
          />
        </Box>
      )}
    </Box>
  );
}
